import { BuildType } from './ApiService';

export const userAdminService = (build: BuildType) => ({
    checkAdmin: build.query<{ isAdmin: boolean }, void>({
        query: () => 'user-admin/check',
        providesTags: ['UserAdmin'],
    }),
});
